import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import { makeStyles } from 'styles/util';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SeoBlockFaqItem from 'components/SeoBlockFaqItem';

const useStyles = makeStyles(({ theme }) => ({
	addFaqItemButton: {
		padding: theme.spacing(1, 2),
	}
}));

const SeoBlockFaq = ({ blockName, onBlur }) => {
	const classes = useStyles();

	const handleAddFaqItem = fields => {
		fields.push({ question: '', answer: '' });
	};

	return (
		<Grid item xs={12}>
			<FieldArray name={`${blockName}.faqItems`}>
				{({ fields }) => (
					<>
						{fields.length === 0 && fields.push({ question: '', answer: '' })}
						{fields.map((faqName, faqIndex) => (
							<Grid container spacing={1} key={faqName}>
								<SeoBlockFaqItem
									blockName={faqName}
									onBlur={onBlur}
									onRemove={() => fields.remove(faqIndex)}
									canRemove={fields.length > 1}
								/>
							</Grid>
						))}
						<Button
							variant="outlined"
							color="primary"
							className={classes.addFaqItemButton}
							onClick={() => handleAddFaqItem(fields)}
						>
							Add FAQ item
						</Button>
					</>
				)}
			</FieldArray>
		</Grid>
	);
};

SeoBlockFaq.propTypes = {
	blockName: PropTypes.string.isRequired,
	onBlur: PropTypes.func.isRequired
};

export default SeoBlockFaq;
